export enum ProgramErrorCodes {
	ProgramNameTooLong = "PROGRAM_NAME_TOO_LONG",
}

export class ProgramNameTooLong extends Error {
	public constructor(message?: string) {
		super(message);
	}
}
